enum QuantityStepperType {
  OUTLINED = 'outlined',
  FILLED = 'filled',
}

enum QuantityStepperSize {
  SMALL = 'small',
  MEDIUM = 'medium',
}
enum QuantityStepperStatus {
  VALID = 'valid',
  INVALID = 'invalid',
  DEFAULT = 'default',
}
enum QuantityStepperWidth {
  DEFAULT = 'default-width',
  FULL_WIDTH = 'full-width',
}
export { QuantityStepperType, QuantityStepperSize, QuantityStepperStatus, QuantityStepperWidth };
